import { API } from "../utils";

export const getReports = async ({ params }) => {
  const response = API.get("/organization/reports", { params });
  const data = await response;
  return data;
};

export const getSingleReport = async ({ params }) => {
  const response = API.get(`/organization/reports/${params.id}/generate`, {
    params,
  });
  const data = await response;
  return data;
};

export const getActivitiesExcel = async ({ params }) => {
  const response = API.get(`/organization/activities/excel/export`, { params });
  const data = await response;
  return data;
};
